import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: 'communityTexts',
      method: 'get',
      request: tag => ({ url: apiRoutes.communityTexts(tag) }),
    },
  ])(ComposedComponent);
